import { useEffect, useState } from "react";
import styles from "./driverJobDelivery.module.css";
import dayjs from "dayjs";
import { TextField, Button, Table, TableCell, TableHead, TableContainer, Paper, TableBody, TableRow, TableFooter, Snackbar, Alert, Typography, Checkbox, Dialog, DialogTitle, IconButton, DialogContent, Tooltip } from "@mui/material";
import { Add, PrintOutlined } from "@mui/icons-material";
import { StyledMainTableCell, StyledMainTableRow } from "../../components/TableComponent";
import TablePaginationComponent from "../../components/TablePagination";
import { Close, ArrowForwardOutlined } from "@mui/icons-material";
import axios from "axios";
import Loader from "../../components/Loader";
import { TableLoader } from "../../components/ContentLoader";
import { authData, withAdminAuth } from "../../components/GetAuth";
import AssignPopup from "./assignedPopup";
import AddDriverForm from "../driver/AddDriverForm";
import { ComponentToPrint } from "./driverJobDeliveryPrint";
import { ComponentToPrintList } from "./driverJobDeliveryListPrint";
import { useReactToPrint, ReactToPrint, PrintContextConsumer } from "react-to-print";
import { Home, Plus, Search, X } from "react-feather";
import { useRef } from "react";
import { useCallback } from "react";
import UpdateNotePopup from "./UpdateNotePopup";

const ButtonArea = ({ data }) => {
  const componentRef = useRef();

  const Export = ({ onExport }) => (<Button onClick={(e) => onExport(e.target.value)} className="TableAddBU" style={{ width: "auto" }}>Export To CSV</Button>);

  const convertArrayOfObjectsToCSV = (array) => {
    let result = "";

    const columnDelimiter = ",";
    const lineDelimiter = "\n";
    const keys = ["driver_name", "booking_id", "address", "contact_no", "recepient_name", "order_status", "delivery_notes", "assigned_date"];

    keys.forEach((key) => {
      if (key === "driver_name") {
        result += "Driver Name";
      } else if (key === "booking_id") {
        result += "Booking Id";
      } else if (key === "address") {
        result += "Address";
      } else if (key === "contact_no") {
        result += "Contact No";
      } else if (key === "recepient_name") {
        result += "Recepient Name";
      } else if (key === "order_status") {
        result += "Order Status";
      } else if (key === "delivery_notes") {
        result += "Delivery Notes";
      } else if (key === "assigned_date") {
        result += "Assigned Date";
      } else {
        result += key;
      }
      result += columnDelimiter;
    });
    result += lineDelimiter;

    array.forEach((item) => {
      let ctr = 0;
      keys.forEach((key) => {
        if (ctr > 0) result += columnDelimiter;
        result += item[key];
        ctr++;
      });
      result += lineDelimiter;
    });

    return result;
  };

  const downloadCSV = useCallback(() => {
    let newArray = data.map((row) => {
      return {
        driver_name: row?.delivery_driver?.name,
        booking_id: row?.booking_id,
        address: row?.recipient_details?.address.replace(/,/g, ""),
        contact_no: row?.recipient_details?.phone,
        recepient_name: row?.recipient_details?.name,
        order_status: row?.payment_status === 1 || row?.payment_status === "1" ? "Paid" : "Unpaid",
        delivery_notes: row?.delivery_note,
        assigned_date: dayjs(row?.delivery_driver?.updated_at).format("DD/MM/YYYY"),
      };
    });

    const link = document.createElement("a");
    let csv = convertArrayOfObjectsToCSV(newArray);
    if (csv == null) return;

    const filename = "driver-jobs.csv";

    if (!csv.match(/^data:text\/csv/i)) {
      csv = `data:text/csv;charset=utf-8,${csv}`;
    }
    link.setAttribute("href", encodeURI(csv));
    link.setAttribute("download", filename);
    link.click();
  }, [data]);

  const handlePrint = useReactToPrint({
    content: () => componentRef.current,
  });

  return (<>
    <Export onExport={() => downloadCSV()} />
    <Button onClick={handlePrint} className="TableAddBU" style={{ width: "auto" }}>Print Bookings</Button>
    <div style={{ display: "none" }}>
      <ComponentToPrintList ref={componentRef} data={data} />
    </div>
  </>);
};

const DriverJobDelivery = () => {
  const auth = authData();
  const componentRef = useRef();
  const API_TOKEN = auth?.api_token;
  const [loading, setLoading] = useState(false);
  const [contentLoading, setContentLoading] = useState(true);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [allData, setAllData] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [filterVars, setFilterVars] = useState({ searchKey: "", date: null });
  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMessage, setSnackbarMessage] = useState("");
  const [snackbarType, setSnackbarType] = useState("success");
  const [selected, setSelected] = useState([]);
  const [formOpen, setFormOpen] = useState(false);
  const [driverFormOpen, setDriverFormOpen] = useState(false);
  const [selectedId, setSelectedId] = useState(0);
  const [noteModalOpen, setNoteModalOpen] = useState(false);
  const [selectBooking, setSelectBooking] = useState(null);
  const [noteData, setNoteData] = useState(null);

  const paginationChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const paginationChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  useEffect(() => {
    const fetchBookings = () => {
      setContentLoading(true);
      axios.get(process.env.REACT_APP_API_URL + "v1/delivery/assigned-bookings", {
        headers: {
          Authorization: `Bearer ${API_TOKEN}`,
        }
      }).then((response) => {
        setContentLoading(false);
        setAllData(response.data.data);
      }).catch((error) => {
        setContentLoading(false);
      });
    };

    fetchBookings();
  }, [API_TOKEN]);

  useEffect(() => {
    let filterredTempData = allData;

    if (filterVars?.searchKey !== "") {
      let inputVal = filterVars?.searchKey;
      inputVal = inputVal.toLowerCase();
      filterredTempData = filterredTempData.filter((item) => {
        return (item?.delivery_driver?.name.toLowerCase().includes(inputVal) || item?.booking_id.toLowerCase().includes(inputVal) || item?.recipient_details?.address.toLowerCase().includes(inputVal) || item?.recipient_details?.phone.toLowerCase().includes(inputVal) || item?.recipient_details?.name.toLowerCase().includes(inputVal));
      });
    }

    setFilteredData(filterredTempData);
  }, [allData, filterVars]);

  const selectRowEvent = (id) => {
    const selectedIndex = selected.indexOf(id);
    let newSelected = [];

    if (selectedIndex === -1) {
      newSelected = newSelected.concat(selected, id);
    } else if (selectedIndex === 0) {
      newSelected = newSelected.concat(selected.slice(1));
    } else if (selectedIndex === selected.length - 1) {
      newSelected = newSelected.concat(selected.slice(0, -1));
    } else if (selectedIndex > 0) {
      newSelected = newSelected.concat(selected.slice(0, selectedIndex), selected.slice(selectedIndex + 1));
    }
    setSelected(newSelected);
  };

  const assignDrivers = () => {
    if (selected.length === 0) {
      setSnackbarType("error");
      setSnackbarOpen(true);
      setSnackbarMessage("Please select item(s)");

      return false;
    }
    let postData = { bookingIds: selected };

    axios.post(process.env.REACT_APP_API_URL + "v1/delivery/make-as-delivered", postData, {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      if (response.data.status === "SUCCESS") {
        axios(process.env.REACT_APP_API_URL + "v1/delivery/assigned-bookings", {
          headers: {
            Authorization: `Bearer ${API_TOKEN}`,
          }
        }).then((response) => {
          if (response.data.status === "SUCCESS") {
            setSnackbarOpen(true);
            setSnackbarMessage(response.data.message);
            setSnackbarType("success");
            setAllData(response.data.data);
          } else {
            setLoading(false);
          }
        }).catch((error) => {
          setLoading(false);
        });
      } else {
        setLoading(false);
      }
    }).catch((error) => {
      setLoading(false);
    });
  };

  const onAssign = () => {
    setSnackbarType("success");
    setSnackbarOpen(true);
    setSnackbarMessage("Driver assigned successfully.");

    axios.get(process.env.REACT_APP_API_URL + "v1/delivery/assigned-bookings", {
      headers: {
        Authorization: `Bearer ${API_TOKEN}`,
      }
    }).then((response) => {
      setContentLoading(false);
      setAllData(response.data.data);
      setLoading(false);
    }).catch((error) => {
      setContentLoading(false);
    });
  }

  return (<>
    <Loader open={loading} setOpen={setLoading.bind(this)} />
    <div className={`${styles.MainDiv}`}>

      <div className={`${styles.MainCard}`}>
        {contentLoading && <TableLoader />}

        {!contentLoading && (<div className={`${styles.PageTitleWrap}`}>
          <p className={`${styles.PageTitle}`}>View Driver Job For Delivery</p>
          <nav aria-label="breadcrumb">
            <ol className={`${styles.breadcrumb}`}>
              <li className={`${styles.breadcrumbItem}`}><span><Home /></span>Ghana Delvery</li>
              <li className={`${styles.breadcrumbItem} ${styles.active}`}>Driver Job</li>
            </ol>
          </nav>
        </div>)}

        {!contentLoading && (<>
          <div className="TableFilterHead">
            <div className="DataTableSearch WithFilter">
              <Search className="SearchIcon" />
              <TextField type="text" placeholder="Search" value={filterVars?.searchKey} onChange={(e) => setFilterVars((prev) => { return { ...prev, searchKey: e.target.value }; })} />
              {filterVars?.searchKey !== "" && (<Button type="button" className="CloseBU" onClick={(e) => setFilterVars((prev) => { return { ...prev, searchKey: "" }; })}><Close /></Button>)}
            </div>
            <div className="TableFilterBUSec">
              {selected.length > 0 ? (<Typography sx={{ flex: "1 1 100%" }} color="inherit" variant="subtitle1" component="div">{selected.length} item selected                </Typography>) : (<ButtonArea style={{ float: "right" }} data={filteredData}                ></ButtonArea>)}
              <Button className="TableAddBU" onClick={(e) => assignDrivers()}><Add />Delivered</Button>
            </div>
          </div>

          <div className="CusTable">
            <TableContainer component={Paper}>
              <Table sx={{ minWidth: 650 }} aria-label="simple table">
                <TableHead>
                  <TableRow>
                    <StyledMainTableCell padding="checkbox">
                      <Checkbox
                        className="AllCheckbox"
                        color="primary"
                        indeterminate={selected?.length > 0 && selected?.length < filteredData?.length}
                        checked={filteredData?.length > 0 && selected?.length === filteredData?.length}
                        onChange={(e) => {
                          if (e.target.checked) {
                            const newSelected = filteredData.map(
                              (n) => n.id
                            );
                            setSelected(newSelected);
                            return;
                          }
                          setSelected([]);
                        }}
                      />
                    </StyledMainTableCell>
                    <StyledMainTableCell>Driver Name</StyledMainTableCell>
                    <StyledMainTableCell>Booking Id</StyledMainTableCell>
                    <StyledMainTableCell>Address</StyledMainTableCell>
                    <StyledMainTableCell>Contact No</StyledMainTableCell>
                    <StyledMainTableCell>Recepient Name</StyledMainTableCell>
                    <StyledMainTableCell>Order Status</StyledMainTableCell>
                    <StyledMainTableCell>Delivery Note</StyledMainTableCell>
                    <StyledMainTableCell>Assigned Date</StyledMainTableCell>
                    <StyledMainTableCell>Action</StyledMainTableCell>
                  </TableRow>
                </TableHead>

                <TableBody>
                  {filteredData.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((item) => {
                    const isItemSelected = selected.indexOf(item?.id) !== -1;

                    return (<StyledMainTableRow key={item?.id} sx={{ "&:last-child td, &:last-child th": { border: 0, cursor: "pointer" } }}>
                      <TableCell padding="checkbox">
                        <Checkbox color="primary" checked={isItemSelected} onClick={(e) => selectRowEvent(item?.id)} aria-checked={isItemSelected} selected={isItemSelected} />
                      </TableCell>
                      <TableCell component="th" scope="row">{item?.delivery_driver?.name}</TableCell>
                      <TableCell component="th" scope="row">{item?.booking_id}</TableCell>
                      <TableCell component="th" scope="row">{item?.recipient_details?.address}</TableCell>
                      <TableCell component="th" scope="row">{item?.recipient_details?.phone}</TableCell>
                      <TableCell component="th" scope="row">{item?.recipient_details?.name}</TableCell>
                      <TableCell component="th" scope="row">
                        {item?.payment_status === 1 || item?.payment_status === "1" ? (<Button className={`${styles.StatusBU} ${styles.DisaBU}`}>Paid</Button>) : (<Button className={`${styles.StatusBU}`}>Unpaid</Button>)}
                      </TableCell>
                      <TableCell component="th" scope="row">{item?.delivery_note ? <><p>{item?.delivery_note}</p><button className={`${styles.AddNote}`} onClick={(e) => { e.preventDefault(); setNoteModalOpen(true); setNoteData(item?.delivery_note); setSelectBooking(item); }}>Update</button></> : <button className={`${styles.AddNote}`} onClick={(e) => { e.preventDefault(); setNoteModalOpen(true); setNoteData(null); setSelectBooking(item); }}><Plus /> Add Note</button>}</TableCell>
                      <TableCell component="th" scope="row">{dayjs(item?.delivery_driver?.delivered_date).format("DD/MM/YYYY")}</TableCell>
                      <TableCell>
                        <div className={`${styles.ActionDiv}`}>
                          <Tooltip title="Print">
                            <div style={{ display: "none" }}>
                              <ComponentToPrint ref={(el) => (componentRef[item?.id] = el)} bookingData={item} />
                            </div>
                            <ReactToPrint content={() => componentRef[item?.id]}>
                              <PrintContextConsumer>
                                {({ handlePrint }) => (<Button className="ActionBU" onClick={handlePrint}><PrintOutlined /></Button>)}
                              </PrintContextConsumer>
                            </ReactToPrint>
                          </Tooltip>
                          <Tooltip title="Re-assign or un-assign" onClick={(e) => { setFormOpen(true); setSelectedId(item?.id); }}>
                            <Button>
                              <ArrowForwardOutlined />
                            </Button>
                          </Tooltip>
                        </div>
                      </TableCell>
                    </StyledMainTableRow>);
                  })}
                  {filteredData.length === 0 && (<TableRow>
                    <TableCell colSpan={10} align="center">No data found</TableCell>
                  </TableRow>)}
                </TableBody>

                {filteredData?.length > 0 && (<TableFooter>
                  <TableRow>
                    <TablePaginationComponent
                      count={filteredData?.length}
                      colSpan={6}
                      page={page}
                      rowsPerPage={rowsPerPage}
                      handleChangePage={paginationChangePage}
                      handleChangeRowsPerPage={
                        paginationChangeRowsPerPage
                      }
                    />
                  </TableRow>
                </TableFooter>)}
              </Table>
            </TableContainer>
          </div>
        </>)}
      </div>
    </div>

    <Dialog open={formOpen} onClose={(e) => setFormOpen(false)} fullWidth>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Assign Booking Details To Driver</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setFormOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
      <DialogContent>
        <AssignPopup setLoading={setLoading.bind(this)} modalClose={setFormOpen.bind(this)} bookingIds={selectedId} onSubmit={onAssign.bind(this)} />
      </DialogContent>
    </Dialog>

    <Dialog open={driverFormOpen} onClose={(e) => setFormOpen(false)}>
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">Add Driver</DialogTitle>
      <IconButton aria-label="close" onClick={(e) => setDriverFormOpen(false)} sx={{ position: "absolute", right: 8, top: 8 }}><Close /></IconButton>
      <DialogContent>
        <AddDriverForm setFormOpen={setDriverFormOpen.bind(this)} setAllData={setAllData.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} setLoading={setLoading.bind(this)} editData={null} />
      </DialogContent>
    </Dialog>

    <Dialog
      fullWidth
      maxWidth="sm"
      className="NewPopUp"
      open={noteModalOpen}
      onClose={(e) => setNoteModalOpen(false)}
    >
      <DialogTitle id="alert-dialog-title">
        {noteData ? 'Update Delivery Note' : 'Add Delivery Note'}
        <button onClick={(e) => setNoteModalOpen(false)}><X /></button>
      </DialogTitle>
      <DialogContent style={{ paddingTop: '10px' }}>
        <UpdateNotePopup setNoteModalOpen={setNoteModalOpen.bind(this)} noteData={noteData} selectBooking={selectBooking} setLoading={setLoading.bind(this)} setAllData={setAllData.bind(this)} setSnackbarOpen={setSnackbarOpen.bind(this)} setSnackbarMessage={setSnackbarMessage.bind(this)} setSnackbarType={setSnackbarType.bind(this)} />
      </DialogContent>
    </Dialog>

    <Snackbar
      open={snackbarOpen}
      autoHideDuration={6000}
      onClose={(e) => setSnackbarOpen(false)}
      anchorOrigin={{ vertical: "top", horizontal: "right" }}
    >
      <Alert
        onClose={(e) => setSnackbarOpen(false)}
        severity={snackbarType}
        variant="filled"
        sx={{ width: "100%" }}
      >
        {snackbarMessage}
      </Alert>
    </Snackbar>
  </>);
};

export default withAdminAuth(DriverJobDelivery);